import React from 'react'
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SydButton from '../../../../commonDesign/Button'
import { useDetailStyles } from '../../dataMaintenance/TagDetails'

const PermissionGroupDetailSection = ({ form, editing, setEditing, handleReset }) => {
  const detailClasses = useDetailStyles()
  return (
    <div className='h-full'>
      <div className='flex flex-col gap-md pb-2'>
        <div className='flex flex-row items-center justify-between'>
          <div className={detailClasses.detailRow}>
            <div>
              <Controller
                name='name'
                control={form.control}
                rules={{
                  required: true
                }}
                render={(f) => (
                  <SydLabel label='Name' required>
                    <SydInput
                      disabled={!editing}
                      size='lg'
                      {...f.field}
                    />
                  </SydLabel>
                )}
              />
            </div>
          </div>
          {
            !editing && (
              <div className='mt-4'>
                <SydButton
                  variant='primary'
                  size='md'
                  onClick={() => {
                    if (editing) {
                      handleReset()
                    } else {
                      setEditing(true)
                    }
                  }}
                >
                  {editing ? 'Cancel' : 'Edit'}
                </SydButton>
              </div>

            )
          }
        </div>
        <div className={detailClasses.detailRow}>
          <Controller
            name='description'
            control={form.control}
            rules={{
              required: true
            }}
            render={(f) => (
              <SydLabel label='Description' required>
                <SydInput
                  disabled={!editing}
                  className='sm: w-full opal flex gap-md'
                  minWidth='665px'
                  {...f.field}
                />
              </SydLabel>
            )}
          />
        </div>
      </div>
    </div>
  )
}

PermissionGroupDetailSection.propTypes = {
  form: PropTypes.object,
  editing: PropTypes.bool,
  setEditing: PropTypes.func,
  handleReset: PropTypes.func
}

export default PermissionGroupDetailSection
